import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { StyleProps } from '~pricing/components/PackageHeader/types';
import { StyleRules } from './types';

export default createMemoStyles<StyleRules, StyleProps, PricingAppTheme>(
  ({ spacing, type, pricingPalette }: PricingAppTheme) => ({
    Discount: {
      fontWeight: type.fontWeight.medium,
      padding: 0,
      margin: [spacing[2], 0, 0],

      '& button': {
        fontSize: '1em',
        padding: 0,
        border: 'none',
        minHeight: 'auto',
        display: 'inline-block',

        '& svg:last-child': {
          marginLeft: 0,
          fontSize: 'inherit',
        },

        '& span': {
          whiteSpace: 'nowrap',
        },

        '&:hover': {
          background: 'transparent',
          border: 'none',
        },
      },
    },

    SwitchForDiscount: {
      color: pricingPalette.colors.link,
      display: 'flex',
      alignItems: 'center',

      '& svg': {
        marginLeft: spacing[2],
      },
    },

    DiscountApplied: {
      color: pricingPalette.colors.sabaeus,
    },
  })
);
